import { pipe } from 'ramda';

import {
  buildCmsUrl,
  CMSApiBase,
  CMSGroupParams,
  CMSImageBase,
  CMSOrder,
  getResponseCMS,
  LIMIT_500,
} from './base';
import { request } from '@/api/base';
import { TournamentBackend } from '@/api/tournaments';
import { getResponseCamelization } from '@/helpers/api';
import { isCMSV3 } from '@/helpers/conf';

export interface TournamentBanner {
  prizePool: string;
  minBet?: string;
  minSpins?: string;
  backgroundDesktop: CMSImageBase;
  backgroundMobile: CMSImageBase;
  durationFrom: string;
  durationTo: string;
}

export interface Tournament extends CMSApiBase, CMSOrder, CMSGroupParams {
  name: string;
  banner: TournamentBanner;
  gamesTc?: string;
  externalWidgetId?: string;
  ssWidgetId?: string;
  collectionName: string;
  text?: string;
  icon?: CMSImageBase;
  backendTournamentId?: string | null;
  backendTournament?: TournamentBackend | undefined;
}

export const tournamentsCMSV3 = (lang: string) =>
  request<Tournament[]>({
    url: buildCmsUrl({ path: 'tournaments-v-2-s', lang, limit: LIMIT_500 }),
  });

export const tournamentsCMSV4 = (lang: string) =>
  request<Tournament[]>({
    url: buildCmsUrl({
      path: 'tournaments-v-2-s',
      lang,
      limit: LIMIT_500,
      additionalParams: { populate: 'deep' },
    }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<Tournament[]>
    ),
  });

export const tournamentsCMS = isCMSV3 ? tournamentsCMSV3 : tournamentsCMSV4;
